module.exports = __webpack_public_path__ + "7b37e59fc1c4751999470ea6f8a5dcfe.MP3";